"use client"

import HomeDetailsWrapperAccordion from "@/features/homeowners/components/home-details-wrapper-accordion"
import { useWorkscopeLabelStyle, WORKSCOPE_LABEL_COLORS } from "../home-details-wrapper-accordion"

const goodwillGreenStyle = { color: WORKSCOPE_LABEL_COLORS.goodwill } as const
import FormSelectInput from "../../../../shared/components/form-inputs/form-select-input"
import WorkScopeStatusSelect from "../work-scope-status-select"
import FormMultiSelectInput from "../../../../shared/components/form-inputs/form-multi-select-input"
import { workScopeStatusOptions } from "../../constants/options"
import DateStampedTextarea from "../../../../shared/components/form-inputs/form-date-stamped-textarea-input"
import { HomeWithHomeOwnerFormType } from "../../schema/home-with-home-owner.schema"
import { useFormContext, useWatch } from "react-hook-form"
import { useClaimedByOptions } from "../../hooks/use-claimed-by-options"
import { useWorkscopeClaimedBySync } from "../../hooks/use-workscope-claimed-by-sync"
import { GoodwillToggleLabel } from "../goodwill-toggle-label"

const baseFieldName = "home.stormShutters"

function HomeStormShuttersForm() {
    const goodwillLabelStyle = useWorkscopeLabelStyle(true) ?? goodwillGreenStyle
    const { control, setValue, getValues } = useFormContext<HomeWithHomeOwnerFormType>()
    const { options: claimedByOptions, loading: claimedByLoading } = useClaimedByOptions()
    const goodwillShutterInstallOn = useWatch({ control, name: `${baseFieldName}.goodwillShutterInstallOn` })
    
    // Watch status field and claimed by field
    const shutterInstall = useWatch({ control, name: `${baseFieldName}.shutterInstall` })
    const shuttersClaimedBy = useWatch({ control, name: `${baseFieldName}.shuttersClaimedBy` })
    const goodwillShutterInstall = useWatch({ control, name: `${baseFieldName}.goodwillShutterInstall` })
    const goodwillShutterInstallClaimedBy = useWatch({
        control,
        name: `${baseFieldName}.goodwillShutterInstallClaimedBy`,
    })

    useWorkscopeClaimedBySync<HomeWithHomeOwnerFormType>({
        status: shutterInstall,
        claimedBy: shuttersClaimedBy,
        claimedByFieldPath: `${baseFieldName}.shuttersClaimedBy`,
        setValue,
        getValues,
    })
    useWorkscopeClaimedBySync<HomeWithHomeOwnerFormType>({
        status: goodwillShutterInstall,
        claimedBy: goodwillShutterInstallClaimedBy,
        claimedByFieldPath: `${baseFieldName}.goodwillShutterInstallClaimedBy`,
        setValue,
        getValues,
        enabled: !!goodwillShutterInstallOn,
    })

    return (
        <HomeDetailsWrapperAccordion 
            heading="Storm Shutters"
            wrapperClassName="xl:grid-cols-2"
        >
            <WorkScopeStatusSelect workScopeSlug="shutter-install"
                inputGroupProps={{
                    label: <GoodwillToggleLabel title="Shutter Install" toggleName={`${baseFieldName}.goodwillShutterInstallOn` as any} control={control} />,
                }}
                options={workScopeStatusOptions}
                name={`${baseFieldName}.shutterInstall`}
                control={control}
            />
            <FormMultiSelectInput
                inputGroupProps={{ label: "Shutters Claimed By" }}
                options={claimedByOptions}
                name={`${baseFieldName}.shuttersClaimedBy`}
                control={control}
                placeholder={claimedByLoading ? "Loading options..." : "Select"}
                searchPlaceholder="Search options..."
            />
            {goodwillShutterInstallOn && (
                <>
                    <FormSelectInput
                        inputGroupProps={{ label: "Shutter Install Goodwill", labelStyle: goodwillLabelStyle }}
                        options={workScopeStatusOptions}
                        name={`${baseFieldName}.goodwillShutterInstall`}
                        control={control}
                    />
                    <FormMultiSelectInput
                        inputGroupProps={{ label: "Shutter Install Goodwill Claimed By" }}
                        options={claimedByOptions}
                        name={`${baseFieldName}.goodwillShutterInstallClaimedBy`}
                        control={control}
                        placeholder={claimedByLoading ? "Loading options..." : "Select"}
                        searchPlaceholder="Search options..."
                    />
                </>
            )}
            <DateStampedTextarea
                includeUserName
                inputGroupProps={{
                    label: "Shutter Description",
                    wrapperClassName: "xl:col-span-2",
                }}
                rows={3}
                placeholder="Describe the shutter installation work needed"
                name={`${baseFieldName}.shutterDescription`}
                control={control}
            />
        </HomeDetailsWrapperAccordion>
    )
}

export default HomeStormShuttersForm

